module.exports = __webpack_public_path__ + "static/media/bt-favorito-hover.a8b079c7.svg";